import BaseEntity from "./base.entity";

export default class StockOperation extends BaseEntity {
  finalStock() {
    if (this.type === "in") {
      return this.current_stock + this.amount;
    } else if (this.type === "out") {
      return this.current_stock - this.amount;
    } else {
      return this.amount;
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/stock_operation.entity.js